(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentWorkItemActionDetailController', DocumentWorkItemActionDetailController);

    DocumentWorkItemActionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'DocumentWorkItemAction', 'DocumentWorkItem'];

    function DocumentWorkItemActionDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, DocumentWorkItemAction, DocumentWorkItem) {
        var vm = this;

        vm.documentWorkItemAction = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('jmrsignApp:documentWorkItemActionUpdate', function(event, result) {
            vm.documentWorkItemAction = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
